// todo: use options for all util functions for better readability
import lscache from "lscache"; // Modified import (no * as)

// Helper to check if we're in a browser environment
const isBrowser = () => typeof window !== "undefined";

// get rid of any expired items
lscache.flushExpired();


export const LS_NAMES = { HIDDEN_ALERT: "hidden-alert" };

export const LS_VALUE = { HIDDEN: "hidden" };

const options = { default: { expirationMinutes: 24 * 60 } };

function _scopedName(name: string, uid?: string | number): string {
  // add uid if one exists
  return uid ? `${name}-${uid}` : name;
}

export function setInitialPersistentState(
  component: { state?: Record<string, any>; setState: (state: any) => void },
  stateObject: Record<string, any>,
  uid?: string | number
): void {
  if (!isBrowser()) return;
  // create state object if one is not set yet
  if (component.state === undefined) component.state = {};
  for (const stateName in stateObject) {
    if (Object.prototype.hasOwnProperty.call(stateObject, stateName)) {
      const defaultValue = stateObject[stateName];
      const scopedName = _scopedName(stateName, uid);
      const persistentValue = lscache.get(scopedName);
      component.state[stateName] =
        persistentValue !== null ? persistentValue : defaultValue;
    }
  }
}

export function setPersistentState(
  component: { setState: (state: any) => void },
  stateObject: Record<string, any>,
  uid?: string | number
): void {
  if (!isBrowser()) return;
  for (const stateName in stateObject) {
    if (Object.prototype.hasOwnProperty.call(stateObject, stateName)) {
      const stateValue = stateObject[stateName];
      // third argument is expiration time in minutes and
      // expiration is not currently being used
      const scopedName = _scopedName(stateName, uid);
      lscache.set(scopedName, stateValue, options.default.expirationMinutes);
    }
  }
  component.setState(stateObject);
}

//
export function setExpiringPersistentData(
  name: string,
  value: any,
  uid?: string | number,
  expirationMinutes?: number
): void {
  if (!isBrowser()) return;
  const scopedName = _scopedName(name, uid);
  lscache.set(scopedName, value, expirationMinutes);
}

// pass in a object or a string
// using a string will return any persisting data with name matching that string
// using a object will do a similar effect but can also expect default values
export function getPersistentData(
  valueObject: string | Record<string, any>,
  uid?: string | number
): any {
  if (!isBrowser()) return null;
  let value;
  if (typeof valueObject === "string") {
    value = lscache.get(_scopedName(valueObject, uid));
  } else {
    for (const valueName in valueObject) {
      if (Object.prototype.hasOwnProperty.call(valueObject, valueName)) {
        const defaultValue = valueObject[valueName];
        const persistentValue = lscache.get(_scopedName(valueName, uid));
        // create object if one does not exist
        if (value === undefined) value = {} as Record<string, any>;
        value[valueName] =
          persistentValue !== undefined ? persistentValue : defaultValue;
      }
    }
  }
  return value;
}

export function flush(): void {
  lscache.flush();
}
